import React, { useState, useEffect } from 'react'
import TreatmentCard from '../../components/Cards/OngoingTreatmentCard';
import useApp from '../../store/app/appContext';
import { MoonLoader }from 'react-spinners';
import { COLORS } from '../../config';
import useTreatments from '../../store/treatments/treatmentsContext';
import axios from 'axios';



function OngoingTreatments() {
  
  const [treatments, setTreatments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  const { getPartnerTreatments } = useTreatments();
  
  const { appState: { user, userAccount }} = useApp();
  
  
  useEffect(() => {
    if (treatments.length) return;
    let source = axios.CancelToken.source();
    if (userAccount.isPartner) getPartnerTreatments(source).then(res => {
      const ongoingTreatments = res?.data;
      if (ongoingTreatments) {
        setTreatments(ongoingTreatments);
      }
      setIsLoading(false);
    }).catch(err => {
      if (axios.isCancel(err)) return;
      setIsLoading(false);
    }); 
    return () => source.cancel();
  }, [userAccount])
  

  return (
    <div className='text-secondary bg-white rounded shadow flex flex-col p-4 md:p-10 py-6 md:py-10 flex-grow overflow-auto md:w-1/2 xl:w-full' style={{ minWidth: '300px', minHeight: '300px' }}>
        <div className='flex justify-between'>
            <h1 className="mb-5 text-2xl text-secondary">Ongoing treatments</h1>
        </div>
        {isLoading && 
        <div className='flex justify-around min-h-170 pt-8'>
          <MoonLoader color={COLORS.colorPrimary}/>
        </div> 
        }
        <div className='space-y-4 overflow-auto'>
        {!isLoading ? 
          (treatments.length ?
            treatments.map(treatment => <TreatmentCard key={treatment._id} treatment={treatment} />)
            :
            'No ongoing treatments')
          :
          ''
        }
        </div>
    </div>
  )
}

export default OngoingTreatments

